export class BackendError extends Error {
    public response?: Response;

    constructor(message: string, response: Response = null) {
        super(message);
        this.response = response;
        Object.setPrototypeOf(this, BackendError.prototype);
    }

    public get statusCode(): number {
        if (!this.response)
            return -1;
        return this.response.status;
    }
}